import { useMemo } from 'react';
import withErrorBoundary from '../ErrorBoundary';
import { UI_UPGRADE_BANNER } from '../_core/common/constants/ErrorBoundaryNames';
import { useDisplayBannerOverride } from '../hooks/useDisplayBannerOverride';
import { useFetchUpgradeBannerConfig } from '../hooks/useFetchUpgradeBannerConfig';
import LimitPackBanner from './banner/LimitPackBanner';
import LoadingBanner from './banner/LoadingBanner';
import RemoveBrandingBanner from './banner/RemoveBrandingBanner';
import UsageLimitBanner from './banner/UsageLimitBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const UIUpgradeBanner = ({
  upgradeKey,
  limit,
  value,
  displayThreshold,
  'data-test-id': dataTestId
}) => {
  const displayBannerOverride = useDisplayBannerOverride();
  const isValueBelowDisplayThreshold = useMemo(() => {
    return !displayBannerOverride && displayThreshold && value !== undefined && value >= 0 && value < displayThreshold;
  }, [displayThreshold, value, displayBannerOverride]);
  const {
    loading,
    error,
    data
  } = useFetchUpgradeBannerConfig(upgradeKey, limit, value, displayThreshold);
  if (isValueBelowDisplayThreshold) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingBanner, {});
  }
  if (error || !data) {
    return null;
  }
  const {
    upgradeConfig
  } = data;
  if (limit && value !== undefined && value >= 0 && upgradeConfig.pointType === 'USAGE_LIMIT_BANNER') {
    return /*#__PURE__*/_jsx(UsageLimitBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      hasReachedLimit: value >= limit,
      displayBannerOverride: !!displayBannerOverride,
      displayThreshold: displayThreshold,
      "data-test-id": dataTestId
    });
  }
  if (limit && value !== undefined && value >= 0 && upgradeConfig.pointType === 'LIMIT_PACK_BANNER') {
    return /*#__PURE__*/_jsx(LimitPackBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      displayThreshold: displayThreshold,
      displayBannerOverride: !!displayBannerOverride,
      "data-test-id": dataTestId
    });
  }
  if (upgradeConfig.pointType === 'REMOVE_BRANDING_BANNER') {
    return /*#__PURE__*/_jsx(RemoveBrandingBanner, {
      upgradePoint: upgradeConfig,
      "data-test-id": dataTestId
    });
  }
  return null;
};
export default withErrorBoundary(UIUpgradeBanner, {
  boundaryName: UI_UPGRADE_BANNER
});